import React from 'react';
import '../css/mobileRes.css';
import '../css/tabletRes.css';

const Names = ({ navigation }) => {
	const { next } = navigation;
	return (
		<div className="cl-btn-wrapper">
			<div className='center-it'>
				<div>
					<svg
						width='330'
						height='45'
						viewBox='0 0 419 40'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<g filter='url(#filter0_d)'>
							<path
								d='M36.7297 28.3005C36.7297 29.3926 35.8444 30.2778 34.7523 30.2778C33.6603 30.2778 32.775 29.3926 32.775 28.3005V7.25769C32.775 6.16564 33.6603 5.28035 34.7523 5.28035C35.8444 5.28035 36.7297 6.16564 36.7297 7.25769V28.3005Z'
								fill='black'
							/>
							<path
								d='M36.7297 28.3005C36.7297 29.3926 35.8444 30.2778 34.7523 30.2778C33.6603 30.2778 32.775 29.3926 32.775 28.3005V7.25769C32.775 6.16564 33.6603 5.28035 34.7523 5.28035C35.8444 5.28035 36.7297 6.16564 36.7297 7.25769V28.3005Z'
								fill='white'
							/>
							<path
								d='M43.9243 28.3005C43.9243 29.3926 43.039 30.2778 41.9469 30.2778C40.8549 30.2778 39.9696 29.3926 39.9696 28.3005V14.6463C39.9696 13.5542 40.8549 12.6689 41.9469 12.6689C43.039 12.6689 43.9243 13.5542 43.9243 14.6463V28.3005ZM39.7255 8.09582C39.7255 7.48824 39.9153 6.98374 40.2951 6.5823C40.6857 6.18087 41.239 5.98015 41.9551 5.98015C42.6711 5.98015 43.2245 6.18087 43.6151 6.5823C44.0056 6.98374 44.2009 7.48824 44.2009 8.09582C44.2009 8.69255 44.0056 9.19163 43.6151 9.59307C43.2245 9.98365 42.6711 10.1789 41.9551 10.1789C41.239 10.1789 40.6857 9.98365 40.2951 9.59307C39.9153 9.19163 39.7255 8.69255 39.7255 8.09582Z'
								fill='black'
							/>
							<path
								d='M43.9243 28.3005C43.9243 29.3926 43.039 30.2778 41.9469 30.2778C40.8549 30.2778 39.9696 29.3926 39.9696 28.3005V14.6463C39.9696 13.5542 40.8549 12.6689 41.9469 12.6689C43.039 12.6689 43.9243 13.5542 43.9243 14.6463V28.3005ZM39.7255 8.09582C39.7255 7.48824 39.9153 6.98374 40.2951 6.5823C40.6857 6.18087 41.239 5.98015 41.9551 5.98015C42.6711 5.98015 43.2245 6.18087 43.6151 6.5823C44.0056 6.98374 44.2009 7.48824 44.2009 8.09582C44.2009 8.69255 44.0056 9.19163 43.6151 9.59307C43.2245 9.98365 42.6711 10.1789 41.9551 10.1789C41.239 10.1789 40.6857 9.98365 40.2951 9.59307C39.9153 9.19163 39.7255 8.69255 39.7255 8.09582Z'
								fill='white'
							/>
							<path
								d='M51.2233 8.38876C52.3154 8.38876 53.2007 9.27405 53.2007 10.3661V12.6689H54.8444C55.6533 12.6689 56.3091 13.3247 56.3091 14.1336C56.3091 14.9426 55.6533 15.5983 54.8444 15.5983H54.2368C53.6646 15.5983 53.2007 16.0622 53.2007 16.6345V25.4281C53.2007 26.1007 53.3309 26.589 53.5913 26.8928C53.8625 27.1857 54.3399 27.3322 55.0234 27.3322C55.7371 27.3322 56.4067 27.8517 56.4067 28.5653V29.0769C56.4067 29.7577 55.9542 30.3677 55.2825 30.4785C54.7784 30.5617 54.2852 30.6033 53.8028 30.6033C50.7649 30.6033 49.246 28.9271 49.246 25.5745V16.5639C49.246 16.0306 48.8137 15.5983 48.2804 15.5983H47.8138C47.0049 15.5983 46.3492 14.9426 46.3492 14.1336C46.3492 13.3247 47.0049 12.6689 47.8138 12.6689H49.246V10.3661C49.246 9.27405 50.1313 8.38876 51.2233 8.38876Z'
								fill='black'
							/>
							<path
								d='M51.2233 8.38876C52.3154 8.38876 53.2007 9.27405 53.2007 10.3661V12.6689H54.8444C55.6533 12.6689 56.3091 13.3247 56.3091 14.1336C56.3091 14.9426 55.6533 15.5983 54.8444 15.5983H54.2368C53.6646 15.5983 53.2007 16.0622 53.2007 16.6345V25.4281C53.2007 26.1007 53.3309 26.589 53.5913 26.8928C53.8625 27.1857 54.3399 27.3322 55.0234 27.3322C55.7371 27.3322 56.4067 27.8517 56.4067 28.5653V29.0769C56.4067 29.7577 55.9542 30.3677 55.2825 30.4785C54.7784 30.5617 54.2852 30.6033 53.8028 30.6033C50.7649 30.6033 49.246 28.9271 49.246 25.5745V16.5639C49.246 16.0306 48.8137 15.5983 48.2804 15.5983H47.8138C47.0049 15.5983 46.3492 14.9426 46.3492 14.1336C46.3492 13.3247 47.0049 12.6689 47.8138 12.6689H49.246V10.3661C49.246 9.27405 50.1313 8.38876 51.2233 8.38876Z'
								fill='white'
							/>
							<path
								d='M66.0991 30.6033C63.5929 30.6033 61.5586 29.8167 59.9962 28.2435C58.4447 26.6595 57.669 24.5547 57.669 21.9291V21.4408C57.669 19.6832 58.0053 18.1154 58.678 16.7375C59.3615 15.3488 60.3163 14.2692 61.5423 13.4989C62.7683 12.7286 64.1353 12.3434 65.6434 12.3434C68.0412 12.3434 69.8911 13.1083 71.193 14.6381C72.5058 16.1679 73.1622 18.3324 73.1622 21.1316C73.1622 22.0125 72.4482 22.7265 71.5673 22.7265H61.6562C61.7756 24.1804 62.2584 25.3304 63.1046 26.1767C63.9618 27.023 65.0359 27.4461 66.327 27.4461C67.5638 27.4461 68.6439 27.1048 69.5673 26.4223C70.2876 25.8899 71.3164 25.7861 71.9645 26.4044C72.4968 26.9124 72.5989 27.7442 72.0867 28.2725C71.5135 28.8639 70.8358 29.3534 70.0538 29.7408C68.882 30.3158 67.5638 30.6033 66.0991 30.6033ZM65.6272 15.517C64.5422 15.517 63.6634 15.8967 62.9907 16.6562C62.3289 17.4156 61.9058 18.4735 61.7213 19.8297H68.9634C69.1252 19.8297 69.2564 19.6985 69.2564 19.5367C69.1696 18.2131 68.8169 17.2149 68.1985 16.5422C67.5801 15.8587 66.723 15.517 65.6272 15.517Z'
								fill='black'
							/>
							<path
								d='M66.0991 30.6033C63.5929 30.6033 61.5586 29.8167 59.9962 28.2435C58.4447 26.6595 57.669 24.5547 57.669 21.9291V21.4408C57.669 19.6832 58.0053 18.1154 58.678 16.7375C59.3615 15.3488 60.3163 14.2692 61.5423 13.4989C62.7683 12.7286 64.1353 12.3434 65.6434 12.3434C68.0412 12.3434 69.8911 13.1083 71.193 14.6381C72.5058 16.1679 73.1622 18.3324 73.1622 21.1316C73.1622 22.0125 72.4482 22.7265 71.5673 22.7265H61.6562C61.7756 24.1804 62.2584 25.3304 63.1046 26.1767C63.9618 27.023 65.0359 27.4461 66.327 27.4461C67.5638 27.4461 68.6439 27.1048 69.5673 26.4223C70.2876 25.8899 71.3164 25.7861 71.9645 26.4044C72.4968 26.9124 72.5989 27.7442 72.0867 28.2725C71.5135 28.8639 70.8358 29.3534 70.0538 29.7408C68.882 30.3158 67.5638 30.6033 66.0991 30.6033ZM65.6272 15.517C64.5422 15.517 63.6634 15.8967 62.9907 16.6562C62.3289 17.4156 61.9058 18.4735 61.7213 19.8297H68.9634C69.1252 19.8297 69.2564 19.6985 69.2564 19.5367C69.1696 18.2131 68.8169 17.2149 68.1985 16.5422C67.5801 15.8587 66.723 15.517 65.6272 15.517Z'
								fill='white'
							/>
							<path
								d='M91.0322 21.6524C91.0322 24.3865 90.4192 26.5619 89.1932 28.1784C87.978 29.795 86.3017 30.6033 84.1644 30.6033C82.1029 30.6033 80.4972 29.8601 79.3471 28.3737L79.3252 28.5881C79.2267 29.548 78.4182 30.2778 77.4532 30.2778C76.414 30.2778 75.5715 29.4354 75.5715 28.3961V7.25769C75.5715 6.16564 76.4568 5.28035 77.5488 5.28035C78.6409 5.28035 79.5262 6.16564 79.5262 7.25769V14.3615C80.6654 13.0161 82.2006 12.3434 84.1318 12.3434C86.28 12.3434 87.9672 13.1409 89.1932 14.7358C90.4192 16.3307 91.0322 18.5603 91.0322 21.4246V21.6524ZM87.0775 21.3106C87.0775 19.4011 86.7411 17.969 86.0685 17.0142C85.3958 16.0594 84.4193 15.5821 83.1391 15.5821C81.69 15.5821 80.6053 16.117 79.8849 17.1869C79.6144 17.5887 79.5262 18.0788 79.5262 18.5632V24.355C79.5262 24.8368 79.614 25.3239 79.8797 25.7258C80.6092 26.8293 81.7065 27.381 83.1716 27.381C84.4085 27.381 85.3632 26.9199 86.0359 25.9977C86.7086 25.0755 87.0558 23.6813 87.0775 21.8151V21.3106Z'
								fill='black'
							/>
							<path
								d='M91.0322 21.6524C91.0322 24.3865 90.4192 26.5619 89.1932 28.1784C87.978 29.795 86.3017 30.6033 84.1644 30.6033C82.1029 30.6033 80.4972 29.8601 79.3471 28.3737L79.3252 28.5881C79.2267 29.548 78.4182 30.2778 77.4532 30.2778C76.414 30.2778 75.5715 29.4354 75.5715 28.3961V7.25769C75.5715 6.16564 76.4568 5.28035 77.5488 5.28035C78.6409 5.28035 79.5262 6.16564 79.5262 7.25769V14.3615C80.6654 13.0161 82.2006 12.3434 84.1318 12.3434C86.28 12.3434 87.9672 13.1409 89.1932 14.7358C90.4192 16.3307 91.0322 18.5603 91.0322 21.4246V21.6524ZM87.0775 21.3106C87.0775 19.4011 86.7411 17.969 86.0685 17.0142C85.3958 16.0594 84.4193 15.5821 83.1391 15.5821C81.69 15.5821 80.6053 16.117 79.8849 17.1869C79.6144 17.5887 79.5262 18.0788 79.5262 18.5632V24.355C79.5262 24.8368 79.614 25.3239 79.8797 25.7258C80.6092 26.8293 81.7065 27.381 83.1716 27.381C84.4085 27.381 85.3632 26.9199 86.0359 25.9977C86.7086 25.0755 87.0558 23.6813 87.0775 21.8151V21.3106Z'
								fill='white'
							/>
							<path
								d='M103.695 28.5528C102.534 29.9198 100.885 30.6033 98.7475 30.6033C96.838 30.6033 95.3896 30.0446 94.4023 28.9271C93.4258 27.8096 92.9376 26.193 92.9376 24.0773V14.6463C92.9376 13.5542 93.8229 12.6689 94.9149 12.6689C96.007 12.6689 96.8923 13.5542 96.8923 14.6463V24.0285C96.8923 26.2635 97.8199 27.381 99.6752 27.381C101.263 27.381 102.425 26.9099 103.16 25.9676C103.471 25.568 103.565 25.0508 103.565 24.544V14.6463C103.565 13.5542 104.45 12.6689 105.542 12.6689C106.634 12.6689 107.519 13.5542 107.519 14.6463V28.3617C107.519 29.42 106.662 30.2778 105.603 30.2778H105.52C104.551 30.2778 103.75 29.5209 103.695 28.5528Z'
								fill='black'
							/>
							<path
								d='M103.695 28.5528C102.534 29.9198 100.885 30.6033 98.7475 30.6033C96.838 30.6033 95.3896 30.0446 94.4023 28.9271C93.4258 27.8096 92.9376 26.193 92.9376 24.0773V14.6463C92.9376 13.5542 93.8229 12.6689 94.9149 12.6689C96.007 12.6689 96.8923 13.5542 96.8923 14.6463V24.0285C96.8923 26.2635 97.8199 27.381 99.6752 27.381C101.263 27.381 102.425 26.9099 103.16 25.9676C103.471 25.568 103.565 25.0508 103.565 24.544V14.6463C103.565 13.5542 104.45 12.6689 105.542 12.6689C106.634 12.6689 107.519 13.5542 107.519 14.6463V28.3617C107.519 29.42 106.662 30.2778 105.603 30.2778H105.52C104.551 30.2778 103.75 29.5209 103.695 28.5528Z'
								fill='white'
							/>
							<path
								d='M126 21.6524C126 24.3865 125.387 26.5619 124.161 28.1784C122.946 29.795 121.27 30.6033 119.132 30.6033C117.071 30.6033 115.465 29.8601 114.315 28.3737L114.293 28.5881C114.195 29.548 113.386 30.2778 112.421 30.2778C111.382 30.2778 110.539 29.4354 110.539 28.3961V7.25769C110.539 6.16564 111.425 5.28035 112.517 5.28035C113.609 5.28035 114.494 6.16564 114.494 7.25769V14.3615C115.633 13.0161 117.168 12.3434 119.1 12.3434C121.248 12.3434 122.935 13.1409 124.161 14.7358C125.387 16.3307 126 18.5603 126 21.4246V21.6524ZM122.045 21.3106C122.045 19.4011 121.709 17.969 121.036 17.0142C120.364 16.0594 119.387 15.5821 118.107 15.5821C116.658 15.5821 115.573 16.117 114.853 17.1869C114.582 17.5887 114.494 18.0788 114.494 18.5632V24.355C114.494 24.8368 114.582 25.3239 114.848 25.7258C115.577 26.8293 116.674 27.381 118.139 27.381C119.376 27.381 120.331 26.9199 121.004 25.9977C121.676 25.0755 122.024 23.6813 122.045 21.8151V21.3106Z'
								fill='black'
							/>
							<path
								d='M126 21.6524C126 24.3865 125.387 26.5619 124.161 28.1784C122.946 29.795 121.27 30.6033 119.132 30.6033C117.071 30.6033 115.465 29.8601 114.315 28.3737L114.293 28.5881C114.195 29.548 113.386 30.2778 112.421 30.2778C111.382 30.2778 110.539 29.4354 110.539 28.3961V7.25769C110.539 6.16564 111.425 5.28035 112.517 5.28035C113.609 5.28035 114.494 6.16564 114.494 7.25769V14.3615C115.633 13.0161 117.168 12.3434 119.1 12.3434C121.248 12.3434 122.935 13.1409 124.161 14.7358C125.387 16.3307 126 18.5603 126 21.4246V21.6524ZM122.045 21.3106C122.045 19.4011 121.709 17.969 121.036 17.0142C120.364 16.0594 119.387 15.5821 118.107 15.5821C116.658 15.5821 115.573 16.117 114.853 17.1869C114.582 17.5887 114.494 18.0788 114.494 18.5632V24.355C114.494 24.8368 114.582 25.3239 114.848 25.7258C115.577 26.8293 116.674 27.381 118.139 27.381C119.376 27.381 120.331 26.9199 121.004 25.9977C121.676 25.0755 122.024 23.6813 122.045 21.8151V21.3106Z'
								fill='white'
							/>
							<path
								d='M20.7606 24.9478C20.8299 24.7429 20.888 24.5329 20.9341 24.3185C20.9405 24.2945 20.9467 24.2699 20.9525 24.2445C21.5744 21.5499 23.3337 19.223 24.1357 18.3964V18.3098C25.4623 16.4977 26.2455 14.2628 26.2455 11.8449C26.2455 5.79407 21.3403 0.888901 15.2894 0.888901C9.23859 0.888901 4.3334 5.79407 4.3334 11.8449C4.3334 14.7536 5.46683 17.3974 7.31611 19.359C8.10261 20.4119 9.06115 22.0016 9.55579 23.7844C9.60346 24.1863 9.69241 24.5755 9.81828 24.9478H20.7606Z'
								stroke='white'
								strokeWidth='0.6666'
							/>
							<rect
								x='8.99712'
								y='25.6511'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='25.6511'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='25.6511'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='white'
							/>
							<rect
								x='8.99712'
								y='27.2797'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='27.2797'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='27.2797'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='white'
							/>
							<rect
								x='8.99712'
								y='28.9083'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='28.9083'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='black'
							/>
							<rect
								x='8.99712'
								y='28.9083'
								width='12.5106'
								height='1.25846'
								rx='0.629232'
								fill='white'
							/>
							<path
								d='M11.9278 8.14357C12.1519 8.14357 12.3338 8.21976 12.4735 8.37215C12.6132 8.52785 12.683 8.72165 12.683 8.95354C12.683 9.18875 12.6132 9.38255 12.4735 9.53494C12.3338 9.69064 12.1519 9.76849 11.9278 9.76849C11.7069 9.76849 11.5267 9.69229 11.387 9.53991C11.2506 9.38752 11.1823 9.19206 11.1823 8.95354C11.1823 8.71834 11.2506 8.52454 11.387 8.37215C11.5267 8.21976 11.7069 8.14357 11.9278 8.14357ZM15.9182 8.14357C16.1424 8.14357 16.3243 8.21976 16.4639 8.37215C16.6036 8.52785 16.6734 8.72165 16.6734 8.95354C16.6734 9.18875 16.6036 9.38255 16.4639 9.53494C16.3243 9.69064 16.1424 9.76849 15.9182 9.76849C15.6974 9.76849 15.5171 9.69229 15.3774 9.53991C15.241 9.38752 15.1728 9.19206 15.1728 8.95354C15.1728 8.71834 15.241 8.52454 15.3774 8.37215C15.5171 8.21976 15.6974 8.14357 15.9182 8.14357Z'
								fill='white'
							/>
							<path
								d='M13.9839 12.7382C13.6745 12.7382 13.4236 12.4873 13.4236 12.1779L13.4236 10.5529C13.4236 10.2435 13.6745 9.99263 13.9839 9.99263C14.2934 9.99263 14.5443 10.2435 14.5443 10.5529L14.5443 12.1779C14.5443 12.4873 14.2934 12.7382 13.9839 12.7382Z'
								fill=''
							/>
							<path
								d='M14.0117 15.3717C13.2738 15.3717 12.5638 15.265 11.8815 15.0516C11.1991 14.8383 10.5968 14.5314 10.0744 14.1309C9.71137 13.8525 9.42716 13.5607 9.22181 13.2554C9.07989 13.0444 9.19754 12.772 9.43619 12.6842C9.62024 12.6165 9.82442 12.6804 9.96155 12.8206C10.3032 13.1699 10.7701 13.454 11.3624 13.673C12.0904 13.9422 12.9278 14.0817 13.8745 14.0915L14.1341 14.0915C15.1102 14.0915 15.9705 13.9569 16.7148 13.6878C17.3271 13.4691 17.8134 13.1782 18.1739 12.8151C18.311 12.6771 18.5136 12.6157 18.6962 12.6829C18.9366 12.7714 19.0549 13.046 18.9113 13.2582C18.7116 13.5533 18.4382 13.836 18.0909 14.1063C17.5849 14.5035 16.9956 14.8104 16.3231 15.027C15.6505 15.2469 14.9535 15.3618 14.232 15.3717L14.0117 15.3717Z'
								fill='white'
							/>
							<text x='33%' y='74%' fill='#fff' fontSize='1.6em'>
							Create shareable chat links!
							</text>
						</g>
						<defs>
							<filter
								id='filter0_d'
								x='0.000106812'
								y='0.555603'
								width='418.646'
								height='38.6397'
								filterUnits='userSpaceOnUse'
								colorInterpolationFilters='sRGB'>
								<feFlood
									floodOpacity='0'
									result='BackgroundImageFix'
								/>
								<feColorMatrix
									in='SourceAlpha'
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
								/>
								<feOffset dy='4' />
								<feGaussianBlur stdDeviation='2' />
								<feColorMatrix
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
								/>
								<feBlend
									mode='normal'
									in2='BackgroundImageFix'
									result='effect1_dropShadow'
								/>
								<feBlend
									mode='normal'
									in='SourceGraphic'
									in2='effect1_dropShadow'
									result='shape'
								/>
							</filter>
						</defs>
					</svg>
				</div>
				<div onClick={next} className='btnh'>
					<svg
						width='370'
						height='145'
						viewBox='0 0 449 185'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<g filter='url(#filter00_d)'>
							<path
								d='M445 117.77C445 125.635 441.856 133.177 436.26 138.739C430.665 144.3 423.075 147.425 415.161 147.425H67.1214C64.8779 147.425 62.6866 148.102 60.8342 149.367L21.4318 176.29C14.0348 181.344 4 176.047 4 167.088V31.1511C4 23.2862 7.14372 15.7433 12.7396 10.182C18.3354 4.62059 25.9251 1.49625 33.8388 1.49625H415.161C423.075 1.49625 430.665 4.62059 436.26 10.182C441.856 15.7433 445 23.2862 445 31.1511V117.77Z'
								fill='white'
							/>
							<path
								d='M443.32 117.77C443.32 125.186 440.356 132.3 435.076 137.547C429.796 142.795 422.633 145.744 415.161 145.744H67.1214C64.5396 145.744 62.018 146.524 59.8863 147.98L20.4839 174.902C14.2021 179.194 5.68016 174.696 5.68016 167.088V31.1511C5.68016 23.7351 8.64433 16.6208 13.924 11.3737C19.2039 6.12624 26.3673 3.17641 33.8388 3.17641H415.161C422.633 3.17641 429.796 6.12625 435.076 11.3737C440.356 16.6208 443.32 23.7351 443.32 31.1511V117.77Z'
								stroke='black'
								strokeWidth='3.36032'
								strokeLinejoin='round'
							/>
						</g>
						<g filter='url(#filter1_d)'>
							<rect
								x='61.3831'
								y='29'
								width='326.234'
								height='91.388'
								rx='15'
								fill='#48A7FF'
							/>
							<path
								d='M166.379 76.7783C166.311 78.2627 165.91 79.5762 165.178 80.7188C164.445 81.8516 163.415 82.7305 162.087 83.3555C160.769 83.9805 159.26 84.293 157.561 84.293C154.758 84.293 152.551 83.3799 150.94 81.5537C149.328 79.7275 148.523 77.1494 148.523 73.8193V72.7646C148.523 70.6748 148.884 68.8486 149.607 67.2861C150.339 65.7139 151.389 64.5029 152.756 63.6533C154.123 62.7939 155.705 62.3643 157.502 62.3643C160.09 62.3643 162.17 63.0479 163.742 64.415C165.315 65.7725 166.208 67.6475 166.423 70.04H161.296C161.257 68.7412 160.93 67.8086 160.315 67.2422C159.699 66.6758 158.762 66.3926 157.502 66.3926C156.223 66.3926 155.285 66.8711 154.69 67.8281C154.094 68.7852 153.781 70.3135 153.752 72.4131V73.9219C153.752 76.1973 154.035 77.8232 154.602 78.7998C155.178 79.7764 156.164 80.2646 157.561 80.2646C158.742 80.2646 159.646 79.9863 160.271 79.4297C160.896 78.873 161.228 77.9893 161.267 76.7783H166.379ZM178.171 72.6182L176.545 72.501C174.992 72.501 173.996 72.9893 173.557 73.9658V84H168.62V68.1504H173.249L173.41 70.1865C174.24 68.6338 175.398 67.8574 176.882 67.8574C177.409 67.8574 177.868 67.916 178.259 68.0332L178.171 72.6182ZM187.326 84.293C184.895 84.293 182.927 83.5703 181.423 82.125C179.919 80.6699 179.167 78.7803 179.167 76.4561V76.0459C179.167 74.4248 179.465 72.9941 180.061 71.7539C180.666 70.5137 181.545 69.5566 182.697 68.8828C183.85 68.1992 185.217 67.8574 186.799 67.8574C189.025 67.8574 190.783 68.5508 192.072 69.9375C193.361 71.3145 194.006 73.2383 194.006 75.709V77.6279H184.191C184.367 78.5166 184.753 79.2148 185.349 79.7227C185.944 80.2305 186.716 80.4844 187.663 80.4844C189.226 80.4844 190.446 79.9375 191.325 78.8438L193.581 81.5098C192.966 82.3594 192.092 83.0381 190.959 83.5459C189.836 84.0439 188.625 84.293 187.326 84.293ZM186.77 71.666C185.324 71.666 184.465 72.623 184.191 74.5371H189.172V74.1562C189.191 73.3652 188.991 72.7549 188.571 72.3252C188.151 71.8857 187.551 71.666 186.77 71.666ZM204.934 84C204.758 83.6777 204.602 83.2041 204.465 82.5791C203.557 83.7217 202.287 84.293 200.656 84.293C199.162 84.293 197.893 83.8438 196.848 82.9453C195.803 82.0371 195.28 80.8994 195.28 79.5322C195.28 77.8135 195.915 76.5146 197.185 75.6357C198.454 74.7568 200.3 74.3174 202.722 74.3174H204.245V73.4824C204.245 72.0273 203.615 71.2998 202.356 71.2998C201.184 71.2998 200.598 71.876 200.598 73.0283H195.661C195.661 71.4951 196.311 70.25 197.609 69.293C198.918 68.3359 200.583 67.8574 202.605 67.8574C204.626 67.8574 206.223 68.3506 207.395 69.3369C208.566 70.3232 209.167 71.6758 209.196 73.3945V80.4111C209.216 81.8662 209.441 82.9795 209.87 83.751V84H204.934ZM201.843 80.7773C202.458 80.7773 202.966 80.6455 203.366 80.3818C203.776 80.1182 204.069 79.8203 204.245 79.4883V76.9541H202.81C201.091 76.9541 200.232 77.7256 200.232 79.2686C200.232 79.7178 200.383 80.084 200.686 80.3672C200.988 80.6406 201.374 80.7773 201.843 80.7773ZM217.692 64.21V68.1504H220.3V71.5781H217.692V78.8291C217.692 79.4248 217.8 79.8398 218.015 80.0742C218.23 80.3086 218.654 80.4258 219.289 80.4258C219.777 80.4258 220.188 80.3965 220.52 80.3379V83.8682C219.631 84.1514 218.703 84.293 217.736 84.293C216.037 84.293 214.782 83.8926 213.972 83.0918C213.161 82.291 212.756 81.0752 212.756 79.4443V71.5781H210.734V68.1504H212.756V64.21H217.692ZM229.924 84.293C227.492 84.293 225.525 83.5703 224.021 82.125C222.517 80.6699 221.765 78.7803 221.765 76.4561V76.0459C221.765 74.4248 222.063 72.9941 222.658 71.7539C223.264 70.5137 224.143 69.5566 225.295 68.8828C226.447 68.1992 227.815 67.8574 229.397 67.8574C231.623 67.8574 233.381 68.5508 234.67 69.9375C235.959 71.3145 236.604 73.2383 236.604 75.709V77.6279H226.789C226.965 78.5166 227.351 79.2148 227.946 79.7227C228.542 80.2305 229.314 80.4844 230.261 80.4844C231.823 80.4844 233.044 79.9375 233.923 78.8438L236.179 81.5098C235.564 82.3594 234.69 83.0381 233.557 83.5459C232.434 84.0439 231.223 84.293 229.924 84.293ZM229.367 71.666C227.922 71.666 227.063 72.623 226.789 74.5371H231.77V74.1562C231.789 73.3652 231.589 72.7549 231.169 72.3252C230.749 71.8857 230.149 71.666 229.367 71.666ZM251.442 80.0449H260.393V84H246.301V62.6719H251.442V80.0449ZM267.541 84H262.59V68.1504H267.541V84ZM262.297 64.0635C262.297 63.3604 262.551 62.7842 263.059 62.335C263.566 61.8857 264.226 61.6611 265.036 61.6611C265.847 61.6611 266.506 61.8857 267.014 62.335C267.522 62.7842 267.775 63.3604 267.775 64.0635C267.775 64.7666 267.522 65.3428 267.014 65.792C266.506 66.2412 265.847 66.4658 265.036 66.4658C264.226 66.4658 263.566 66.2412 263.059 65.792C262.551 65.3428 262.297 64.7666 262.297 64.0635ZM275.129 68.1504L275.29 70.0107C276.384 68.5752 277.893 67.8574 279.816 67.8574C281.467 67.8574 282.697 68.3506 283.508 69.3369C284.328 70.3232 284.753 71.8076 284.782 73.79V84H279.831V73.9951C279.831 73.1943 279.67 72.6084 279.348 72.2373C279.025 71.8564 278.44 71.666 277.59 71.666C276.623 71.666 275.905 72.0469 275.437 72.8086V84H270.5V68.1504H275.129ZM293.894 78.0967L292.502 79.4883V84H287.566V61.4854H292.502V73.4385L293 72.7793L296.721 68.1504H302.639L297.087 74.6689L303.005 84H297.351L293.894 78.0967Z'
								fill='white'
							/>
						</g>
						<defs>
							<filter
								id='filter00_d'
								x='0.0666196'
								y='0.512901'
								width='448.867'
								height='184.622'
								filterUnits='userSpaceOnUse'
								colorInterpolationFilters='sRGB'>
								<feFlood
									floodOpacity='0'
									result='BackgroundImageFix'
								/>
								<feColorMatrix
									in='SourceAlpha'
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
								/>
								<feOffset dy='2.95003' />
								<feGaussianBlur stdDeviation='1.96669' />
								<feColorMatrix
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
								/>
								<feBlend
									mode='normal'
									in2='BackgroundImageFix'
									result='effect1_dropShadow'
								/>
								<feBlend
									mode='normal'
									in='SourceGraphic'
									in2='effect1_dropShadow'
									result='shape'
								/>
							</filter>
							<filter
								id='filter1_d'
								x='56.3831'
								y='27'
								width='336.234'
								height='101.388'
								filterUnits='userSpaceOnUse'
								colorInterpolationFilters='sRGB'>
								<feFlood
									floodOpacity='0'
									result='BackgroundImageFix'
								/>
								<feColorMatrix
									in='SourceAlpha'
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
								/>
								<feOffset dy='3' />
								<feGaussianBlur stdDeviation='2.5' />
								<feColorMatrix
									type='matrix'
									values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'
								/>
								<feBlend
									mode='normal'
									in2='BackgroundImageFix'
									result='effect1_dropShadow'
								/>
								<feBlend
									mode='normal'
									in='SourceGraphic'
									in2='effect1_dropShadow'
									result='shape'
								/>
							</filter>
						</defs>
					</svg>
				</div>
			</div>
		</div>
	);
};

export default Names;
